import { Box } from '@material-ui/core';
import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";

type PeRecaptchaProps = {
  readonly id?: string | "";
  readonly onExpired: any;
  readonly onChange: any;
}

// const siteKeyv3 = "6LdfnKwcAAAAAF6RoXvWdXdZnV5oyOavq6P6gymA";
const siteKeyv2 = "6LdwoqwcAAAAAJKW-yZZr4PT3QhAvTy2n9EIDsqB";
// const siteKeyTest = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

const PeRecaptcha = React.forwardRef<ReCAPTCHA, PeRecaptchaProps>((props, ref) => {
  return <Box mt={2} sx={{ p: 2 }} id={props.id}>
    <ReCAPTCHA
      ref={ref}
      sitekey={siteKeyv2}
      onChange={props.onChange}
      onExpired={props.onExpired}
      size="normal"
    />
  </Box>
})

export default PeRecaptcha;